// src/repositories/stockTransfersRepository.js
import { getDb } from '../lib/db'
import { supabase } from '../lib/supabase'

export async function getTransfers({ businessId, branchId, start, end } = {}) {
  const db = await getDb().catch(() => null)
  if (db && db.stock_transfers) {
    const selector = {}
    if (businessId) selector.business_id = businessId
    if (branchId) {
      selector.$or = [
        { from_branch_id: branchId },
        { to_branch_id: branchId },
      ]
    }
    if (start || end) {
      selector.created_at = {}
      if (start) selector.created_at.$gte = start
      if (end) selector.created_at.$lte = end
    }

    return db.stock_transfers.find({
      selector,
      sort: [
        { created_at: 'desc' },
        { id: 'desc' },
      ],
    }).exec()
  }

  let q = supabase.from('stock_transfers').select('*')
  if (businessId) q = q.eq('business_id', businessId)
  if (branchId) q = q.or(`from_branch_id.eq.${branchId},to_branch_id.eq.${branchId}`)
  if (start) q = q.gte('created_at', start)
  if (end) q = q.lte('created_at', end)
  const { data, error } = await q.order('created_at', { ascending: false })
  if (error) throw error
  return data
}

export async function getTransferById(id) {
  const db = await getDb().catch(() => null)
  if (db && db.stock_transfers) {
    const doc = await db.stock_transfers.findOne(id).exec()
    return doc ? doc.toJSON() : null
  }

  const { data, error } = await supabase.from('stock_transfers').select('*').eq('id', id).single()
  if (error) throw error
  return data
}

export async function upsertTransfer(transfer) {
  const db = await getDb().catch(() => null)
  if (db && db.stock_transfers) {
    const toUpsert = { ...transfer, _modified: Date.now() }
    await db.stock_transfers.upsert(toUpsert)
    return toUpsert
  }

  const { data, error } = await supabase.from('stock_transfers').upsert(transfer).select().single()
  if (error) throw error
  return data
}

export async function removeTransfer(id) {
  const db = await getDb().catch(() => null)
  if (db && db.stock_transfers) {
    const doc = await db.stock_transfers.findOne(id).exec()
    if (doc) await doc.atomicRemove()
    return true
  }

  const { error } = await supabase.from('stock_transfers').delete().eq('id', id)
  if (error) throw error
  return true
}

export async function updateTransferStatus(id, status, receivedBy = null) {
  const db = await getDb().catch(() => null)
  if (db && db.stock_transfers) {
    const doc = await db.stock_transfers.findOne(id).exec()
    if (!doc) throw new Error('Transfer not found')
    const updates = { status }
    if (receivedBy) updates.received_by = receivedBy
    if (status === 'received') updates.received_at = new Date().toISOString()
    await doc.update({ $set: updates })
    return true
  }

  const { error } = await supabase.from('stock_transfers').update({ status, received_by: receivedBy, received_at: status === 'received' ? new Date().toISOString() : null }).eq('id', id)
  if (error) throw error
  return true
}

export default {
  getTransfers,
  getTransferById,
  upsertTransfer,
  removeTransfer,
  updateTransferStatus,
}
